import React, { useRef } from "react"
import { injectIntl, Link } from "gatsby-plugin-intl"
import "flickity/css/flickity.css"
import styled from "@emotion/styled"
const Flickity =
  typeof window !== `undefined` ? require("react-flickity-component") : null

const flickityOptions = {
  freeScroll: false,
  pageDots: false,
  wrapAround: true,
  prevNextButtons: true,
  initialIndex: 1,
}

const CustomerFeedbackSlider = ({ intl, data }) => {
  var prevNext = useRef()
  return typeof window !== "undefined" ? (
    <Carousel className="carousel">
      <DesktopSlider style={{ width: "100%" }}>
        <Flickity
          flickityRef={c => (prevNext = c)}
          options={flickityOptions}
          className={"carousel"}
        >
          {data.list.map((item, index) => {
            return (
              <Row key={index.toString()}>
                <Card>
                  <LeftDiv>
                    <ImageBox>
                      {item.logo && (
                        <Image
                          className="lazyload"
                          data-src={item.logo}
                          alt=""
                        />
                      )}
                    </ImageBox>
                    <GraphBox>
                      {item.graph_text &&
                        item.graph_text.map((graph_item, graph_index) => {
                          return (
                            <GraphLineBox
                              key={graph_index.toString()}
                              order={graph_index == 1 ? "last" : ""}
                            >
                              {graph_item.value && (
                                <GraphLine
                                  height={graph_item.value}
                                  color={
                                    index == 2
                                      ? "#BC0000"
                                      : index == 1
                                      ? "#9EDAED"
                                      : "#5dbabc"
                                  }
                                />
                              )}
                              {graph_item.text && (
                                <GraphText
                                  dangerouslySetInnerHTML={{
                                    __html: graph_item.text,
                                  }}
                                  color={
                                    index == 2
                                      ? "#BC0000"
                                      : index == 1
                                      ? "#9EDAED"
                                      : "#5dbabc"
                                  }
                                />
                              )}
                            </GraphLineBox>
                          )
                        })}
                    </GraphBox>
                    {item.bottom_text && (
                      <BottomText
                        dangerouslySetInnerHTML={{
                          __html: item.bottom_text,
                        }}
                      />
                    )}
                  </LeftDiv>
                  <RightDiv>
                    {item.testimonials &&
                      item.testimonials.map(
                        (testimonials_item, testimonials_index) => {
                          return (
                            <TestimonialBox key={testimonials_index.toString()}>
                              {testimonials_item.text && (
                                <Text
                                  dangerouslySetInnerHTML={{
                                    __html: testimonials_item.text,
                                  }}
                                />
                              )}
                              <AuthorInfo>
                                {testimonials_item.name && (
                                  <Name
                                    dangerouslySetInnerHTML={{
                                      __html: testimonials_item.name,
                                    }}
                                  />
                                )}
                                <Seprator />
                                {testimonials_item.designation && (
                                  <Designation
                                    dangerouslySetInnerHTML={{
                                      __html: testimonials_item.designation,
                                    }}
                                  />
                                )}
                              </AuthorInfo>
                            </TestimonialBox>
                          )
                        }
                      )}
                    {item.button_text &&
                    item.button_url &&
                    item.button_url.indexOf("http") == 0 ? (
                      <OutSiteButton href={item.button_url} target="_blank">
                        {item.button_text}
                      </OutSiteButton>
                    ) : (
                      <Button
                        to={
                          index == 0 &&
                          process.env.GATSBY_CURRENCY_TYPE === "eur" &&
                          intl.locale === "fr"
                            ? "/shop/solutions-textiles/tshirt-discret/?Gender=Female&Collar=V&Color=Noir&Size=&Offer=Seul"
                            : index == 1 &&
                              process.env.GATSBY_CURRENCY_TYPE === "eur" &&
                              intl.locale === "fr"
                            ? "/shop/solutions-textiles/tshirt-sport/?Gender=Female&Collar=Rond&Color=Noir&Size=&Offer=Seul"
                            : item.button_url
                        }
                      >
                        {item.button_text}
                      </Button>
                    )}
                  </RightDiv>
                </Card>
              </Row>
            )
          })}
        </Flickity>
      </DesktopSlider>
    </Carousel>
  ) : null
}

const Carousel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1080px;
  margin: 0px auto;
  padding-bottom: 10px;

  .carousel {
    @media (max-width: 767px) {
      margin: 0px -20px;
    }
  }

  .flickity-slider {
    display: flex;
  }

  .flickity-prev-next-button {
    background-color: transparent;
    color: #111;
    width: 36px;
    height: 36px;
    border: 2px solid #111;

    :hover {
      background-color: #111;
      color: #fff;
    }
  }
  .flickity-prev-next-button.next {
    right: -50px;

    @media (max-width: 1250px) {
      right: 20px;
    }

    @media (max-width: 767px) {
      right: 10px;
    }
  }
  .flickity-prev-next-button.previous {
    left: -50px;

    @media (max-width: 1250px) {
      left: 20px;
    }

    @media (max-width: 767px) {
      left: 10px;
    }
  }
  .flickity-page-dots {
    bottom: -6px;
    max-width: 105px;
    margin: 0px auto;
    left: 0;
    right: 0;

    @media (max-width: 767px) {
      max-width: 130px;
    }
  }
`

const DesktopSlider = styled.div`
  width: 100%;
  display: block;
`

const Row = styled.div`
  width: 90%;
  max-width: 850px;
  padding: 0px 10px;

  :not(.is-selected) {
    opacity: 0.4;
  }

  @media (max-width: 550px) {
    width: 80%;
  }
`

const Card = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: 0px 3px 10px 1px rgba(206, 206, 206, 0.5);
  margin: 10px 0px;
  border-radius: 6px;
  min-height: 390px;

  @media (max-width: 550px) {
    flex-direction: column;
    min-height: 700px;
  }

  @media (max-width: 400px) {
    flex-direction: column;
    min-height: 740px;
  }

  @media (max-width: 365px) {
    flex-direction: column;
    min-height: 755px;
  }

  @media (max-width: 340px) {
    flex-direction: column;
    min-height: 775px;
  }

  @media (max-width: 335px) {
    flex-direction: column;
    min-height: 830px;
  }
`

const LeftDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;

  @media (max-width: 550px) {
    padding: 10px 0px;
  }
`

const RightDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding: 10px;

  @media (max-width: 550px) {
    padding: 10px 0px;
    flex: 1;
  }
`

const ImageBox = styled.div`
  max-width: 140px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
`

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  margin: 0;
`

const GraphBox = styled.div`
  width: 100%;
  max-width: 310px;
  height: 175px;
  border: 1px solid #262626;
  border-top: 0px;
  border-right: 0px;
  margin: 15px 10px;
  position: relative;

  @media (max-width: 550px) {
    margin: 15px 0px;
  }

  :before {
    content: "";
    position: absolute;
    left: -6px;
    transform: translate(-1px, 0px);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #262626;
  }

  :after {
    content: "";
    position: absolute;
    right: -5px;
    bottom: -6px;
    transform: translate(-1px, 0px);
    border-left: 6px solid #262626;
    border-bottom: 6px solid transparent;
    border-top: 6px solid transparent;
  }
`

const GraphLineBox = styled.div`
  border-radius: 3px 3px 0px 0px;
  position: absolute;
  left: ${({ order }) => (order ? "50%" : "10%")};
  height: 100%;
  display: flex;
  align-items: flex-end;

  @media (max-width: 550px) {
    left: ${({ order }) => (order ? "58%" : "7%")};
  }
`

const GraphLine = styled.div`
  width: 21px;
  height: ${({ height }) => (height ? height : "73%")};
  background-color: ${({ color }) => (color ? color : "#5dbabc")};
  border-radius: 3px 3px 0px 0px;
`

const GraphText = styled.div`
  display: flex;
  flex-direction: column;
  color: #262626;
  font-family: "Gotham";
  font-weight: bold;
  font-size: 14px;
  line-height: 1.2;
  max-width: 95px;
  margin-left: 3px;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translate(0px, -50%);

  > span {
    color: ${({ color }) => (color ? color : "#5dbabc")};
    font-size: 24px;
    display: block;
  }
`

const TestimonialBox = styled.div`
  padding: 10px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 5px 2px rgba(206, 206, 206, 0.5);
  background: #fff;
  border-radius: 3px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const Text = styled.div`
  font-size: 16px;
  line-height: 1.2;
  font-family: "Gotham";
  font-weight: bold;
  color: #262626;
`

const AuthorInfo = styled.div`
  display: flex;
`

const Name = styled.div`
  font-family: "Gotham Book";
  font-size: 16px;
  font-weight: 500;
`

const Seprator = styled.div`
  border-right: 1px solid #262626;
  margin: 0px 10px;
`

const Designation = styled.div`
  font-family: "Gotham Book";
  font-size: 16px;
  font-weight: 500;
`

const BottomText = styled.div`
  font-size: 14px;
  line-height: 1.2;
  font-family: "Gotham Book";
  font-weight: 500;
  margin: 15px 0px 0px;
`

const Button = styled(Link)`
  background-color: #262626;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  font-family: "Gotham Book";
  font-weight: 500;
  display: flex;
  justify-content: center;
  border-radius: 6px;
  padding: 10px 20px;

  :hover {
    color: #fff;
  }

  @media (max-width: 550px) {
    width: 100%;
  }

  @media (max-width: 340px) {
    font-size: 14px;
  }
`

const OutSiteButton = styled.a`
  background-color: #262626;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  font-family: "Gotham Book";
  font-weight: 500;
  display: flex;
  justify-content: center;
  border-radius: 6px;
  padding: 10px 20px;

  :hover {
    color: #fff;
  }

  @media (max-width: 550px) {
    width: 100%;
  }

  @media (max-width: 340px) {
    font-size: 14px;
  }
`

export default injectIntl(CustomerFeedbackSlider)
